module.exports = __webpack_public_path__ + "media/images/home/7-d4ea65a6341007d6abc579e44945ceda.png";